import { Input } from "antd";

const UploadEnterLink = ({ nameForm, label, rules, form }) => (
  <div className="flex flex-col gap-1">
    {label && (
      <label className="text-xs font-medium text-gray-500">{label}</label>
    )}
    <Input placeholder="Enter link or upload info..." />
  </div>
);

export default UploadEnterLink;
